export const MIN_DRIVER_AGE = 25;
export const MAX_DRIVER_AGE = 75;
